import * as React from "react";
const SvgFiRrFaceDisguise = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-disguise_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 2c4.091 0 7.612 2.473 9.159 6h-1.436c-.621-1.742-2.271-3-4.224-3-1.421 0-2.675.675-3.5 1.706C11.174 5.674 9.92 5 8.499 5 6.546 5 4.897 6.258 4.275 8H2.84c1.547-3.527 5.068-6 9.159-6zm0 14c-1.094 0-3-.85-3-1.337 0-.291.132-.56.349-.749A4.48 4.48 0 0 0 12 12.293a4.5 4.5 0 0 0 2.652 1.621 1 1 0 0 1 .349.742C14.906 15.134 12.972 16 12 16M8.5 7C9.879 7 11 8.121 11 9.5S9.879 12 8.5 12A2.5 2.5 0 0 1 6 9.5C6 8.121 7.121 7 8.5 7m7 5A2.5 2.5 0 0 1 13 9.5C13 8.121 14.121 7 15.5 7S18 8.121 18 9.5 16.879 12 15.5 12M12 22C6.486 22 2 17.514 2 12q.002-1.03.202-2h1.849a4.48 4.48 0 0 0 3.101 3.771 3 3 0 0 0-.152.892q.002.203.039.395l-1.106.788a1 1 0 1 0 1.16 1.629l1.086-.773c.342.256.731.472 1.135.65l-.454 1.324a1.002 1.002 0 0 0 .946 1.325 1 1 0 0 0 .946-.676l.48-1.4c.293.048.559.075.768.075.191 0 .458-.031.764-.088l.484 1.412a1 1 0 0 0 1.892-.649l-.467-1.363a6 6 0 0 0 1.115-.635l1.118.796a.999.999 0 1 0 1.16-1.629l-1.108-.789a2 2 0 0 0 .041-.393c0-.309-.063-.605-.153-.892a4.48 4.48 0 0 0 3.102-3.771h1.849c.132.646.202 1.315.202 2 0 5.514-4.486 10-10 10zM7.5 9.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-disguise_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceDisguise;
